import { render } from "./DetaljiSuveniri.vue?vue&type=template&id=b2db47f4&scoped=true"
import script from "./DetaljiSuveniri.vue?vue&type=script&lang=js"
export * from "./DetaljiSuveniri.vue?vue&type=script&lang=js"

import "./DetaljiSuveniri.vue?vue&type=style&index=0&id=b2db47f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2db47f4"]])

export default __exports__